import React, { useEffect, useState, useRef } from "react";
import 'katex/dist/katex.min.css';
import { InlineMath } from 'react-katex';
import styled, {
	keyframes,
	css
} from "styled-components";
import {
	useParams,
	useSearchParams,
	useLocation,
	Link
}
from "react-router-dom";

import { db } from "../firebase/firebaseConfig";
import { getImagenes } from "../funciones/imagenesStorage";
import motorPreguntas
from "../funciones/motorPreguntas";
import generarPoolPreguntas
from "../funciones/generarPoolPreguntas";
import { registrarEvento } from "../funciones/tracking";
import { useAuth } from "../contextos/AuthContext";
import { obtenerMembresiaActiva } from "../firebase/obtenerMembresiaActiva";
import actualizarProgresoMeta from "../funciones/actualizarProgresoMeta";
import toast from "react-hot-toast";
import { obtenerRango } from "../funciones/rangos";
import obtenerProgresoUsuario from "../firebase/obtenerProgresoUsuario";
import {
	addDoc,
	setDoc,
	doc,
	collection,
	serverTimestamp,
	getDocs
} from "firebase/firestore";
import calcularComponentesExamen
from "../funciones/calcularComponentesExamen";
const filtrosExamen = {
	Examen_Unal: [1, 5, 6],
	Examen_Icfes: [1, 2, 5],
	Examen_Udea: [1, 3, 5],
};


const metaMap = {
	Examen_Unal: "unal",
	Examen_Icfes: "icfes",
	Examen_Udea: "udea"
};

// =========================
// ANIMACIONES
// =========================

const fadeUp = keyframes`
	from {
		opacity: 0;
		transform: translateY(20px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
`;

const shake = keyframes`
	0% { transform: translateX(0); }

	20% { transform: translateX(-8px); }

	40% { transform: translateX(8px); }

	60% { transform: translateX(-6px); }

	80% { transform: translateX(6px); }

	100% { transform: translateX(0); }
`;

const glowSuccess = keyframes`
	0% {
		box-shadow: 0 0 0 rgba(34,197,94,0);
	}

	50% {
		box-shadow:
			0 0 40px rgba(34,197,94,0.5),
			0 0 80px rgba(34,197,94,0.25);
	}

	100% {
		box-shadow: 0 0 0 rgba(34,197,94,0);
	}
`;

const floatXp = keyframes`
	0% {
		opacity: 0;
		transform:
			translateY(20px)
			scale(0.7);
	}

	20% {
		opacity: 1;
		transform:
			translateY(0)
			scale(1);
	}

	100% {
		opacity: 0;
		transform:
			translateY(-80px)
			scale(1.3);
	}
`;

const pulse = keyframes`
	0% {
		transform: scale(1);
	}

	50% {
		transform: scale(1.05);
	}

	100% {
		transform: scale(1);
	}
`;

const levelAnim = keyframes`
	0% {
		opacity: 0;
		transform: scale(0.7);
	}

	20% {
		opacity: 1;
		transform: scale(1.08);
	}

	40% {
		transform: scale(1);
	}

	100% {
		opacity: 1;
		transform: scale(1);
	}
`;

const glowAnim = keyframes`
	0% {
		opacity: 0;
	}

	100% {
		opacity: 1;
	}
`;

// =========================
// ESTILOS
// =========================

const Contenedor = styled.div`
	min-height: 100vh;
	background:
		radial-gradient(circle at top, #1f2937 0%, #0b1120 45%, #050816 100%);
	color: white;
	padding: 2rem;

	@media (max-width: 768px) {
		padding: 1rem;
	}
`;

const Topbar = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 1rem;
	margin-bottom: 1rem;
	flex-wrap: wrap;
`;

const HudBar = styled.div`
	position: sticky;
	top: 0;
	z-index: 20;

	display: flex;
	gap: 1rem;
	flex-wrap: wrap;

	margin-bottom: 2rem;

	padding: 1rem;

	background: rgba(10,15,30,0.75);

	backdrop-filter: blur(14px);

	border: 1px solid rgba(255,255,255,0.08);

	border-radius: 22px;

	box-shadow:
		0 10px 30px rgba(0,0,0,0.35);

	animation: ${pulse} 0.35s ease;
`;

const HudLabel = styled.div`
	font-size: 0.8rem;
	color: rgba(255,255,255,0.5);
`;

const HudValue = styled.div`
	font-size: 1.4rem;
	font-weight: 800;

	color: ${({ color }) => color || "white"};

	text-shadow:
		0 0 12px ${({ color }) =>
			color || "white"};
`;

const BotonBack = styled(Link)`
	background: rgba(255,255,255,0.08);
	border: 1px solid rgba(255,255,255,0.1);
	color: white;
	text-decoration: none;
	padding: 0.9rem 1.2rem;
	border-radius: 16px;
	font-weight: 600;
	transition: 0.25s ease all;

	&:hover {
		background: rgba(91,105,226,0.2);
		border-color: #5b69e2;
		transform: translateY(-2px);
	}
`;

const HeaderInfo = styled.div`
	display: flex;
	gap: 1rem;
	flex-wrap: wrap;
`;

const Badge = styled.div`
	background: rgba(91,105,226,0.18);
	border: 1px solid rgba(91,105,226,0.4);
	color: #8ea2ff;
	padding: 0.9rem 1.2rem;
	border-radius: 16px;
	font-weight: 700;
	font-size: 0.9rem;
`;

const Hud = styled.div`

	position: sticky;

	top: 12px;

	z-index: 200;

	display: flex;

	align-items: center;

	justify-content: center;

	flex-wrap: wrap;

	gap: 0.7rem;

	margin-bottom: 1rem;

	padding: 0.9rem 1rem;

	border-radius: 999px;

	background: rgba(10,15,30,0.78);

	backdrop-filter: blur(14px);

	border: 1px solid rgba(255,255,255,0.08);

	box-shadow:
		0 10px 30px rgba(0,0,0,.25);

`;

const HudItem = styled.div`

	display: flex;

	align-items: center;

	gap: 0.45rem;

	padding: 0.45rem 0.9rem;

	border-radius: 999px;

	background:
		rgba(255,255,255,0.05);

	font-weight: 700;

	font-size: 0.82rem;

	backdrop-filter: blur(8px);

	color: white;

	transition: .25s ease all;

	&:hover {

		transform: translateY(-2px);

		background:
			rgba(91,105,226,.18);
	}
`;

const HudCard = styled.div`
	background: rgba(255,255,255,0.05);

	border: 1px solid rgba(255,255,255,0.08);

	border-radius: 20px;

	padding: 1rem;
`;

const RankCard = styled.div`
	background:
		linear-gradient(
			135deg,
			rgba(255,255,255,0.08),
			rgba(255,255,255,0.03)
		);

	border: 2px solid ${({ color }) => color};

	border-radius: 24px;

	padding: 1.2rem;

	display: flex;
	align-items: center;
	gap: 1rem;

	margin-bottom: 1rem;

	box-shadow:
		0 0 30px ${({ color }) =>
			`${color}55`};

	animation: ${pulse} 1.2s ease;
`;

const PromoCard = styled.div`
	margin-bottom: 2rem;

	padding: 1.2rem;

	border-radius: 24px;

	background:
		linear-gradient(
			135deg,
			rgba(250,204,21,0.15),
			rgba(234,179,8,0.05)
		);

	border:
		2px solid rgba(250,204,21,0.4);

	box-shadow:
		0 0 30px rgba(250,204,21,0.18);

	animation: ${pulse} 1s ease;
`;

const PromoTitle = styled.div`
	font-size: 1.3rem;
	font-weight: 900;

	color: #facc15;

	margin-bottom: 1rem;
`;

const PromoCircles = styled.div`
	display: flex;
	gap: 0.8rem;
`;

const PromoCircle = styled.div`
	width: 22px;
	height: 22px;

	border-radius: 999px;

	background:
		${({ state }) => {

			if (state === "win") {
				return "#22c55e";
			}

			if (state === "loss") {
				return "#ef4444";
			}

			return "rgba(255,255,255,0.15)";
		}};
`;

const RankIcon = styled.div`
	font-size: 3rem;
`;

const RankInfo = styled.div`
	display: flex;
	flex-direction: column;
`;

const RankTitle = styled.div`
	font-size: 1.4rem;
	font-weight: 900;

	color: ${({ color }) => color};
`;

const RankSubtitle = styled.div`
	color: rgba(255,255,255,0.6);
	font-size: 0.95rem;
`;

const HudCardLabel = styled.div`
	font-size: 0.8rem;
	color: rgba(255,255,255,0.55);

	margin-bottom: 0.4rem;
`;

const HudCardValue = styled.div`
	font-size: 1.4rem;
	font-weight: 800;
`;

const BarraXp = styled.div`
	width: 100%;
	height: 10px;

	background: rgba(255,255,255,0.08);

	border-radius: 999px;

	overflow: hidden;

	margin-top: 0.7rem;
`;

const BarraXpFill = styled.div`
	height: 100%;

	width: ${({ progreso }) => progreso}%;

	background: linear-gradient(
		90deg,
		#5b69e2,
		#7c3aed
	);

	transition: 0.5s ease;
	box-shadow:
		0 0 18px rgba(91,105,226,.7);
`;

const comboPulse = keyframes`
	0% {
		transform: scale(0.8);
		opacity: 0;
	}

	100% {
		transform: scale(1);
		opacity: 1;
	}
`;

const Combo = styled.div`
	font-size: 2rem;
	font-weight: 900;

	color: #f97316;

	animation: ${comboPulse} 0.6s ease;
`;

const MainCard = styled.div`

	max-width: 1100px;
	margin: 0 auto;

	background: linear-gradient(
		145deg,
		rgba(255,255,255,0.08),
		rgba(255,255,255,0.03)
	);

	border: 1px solid rgba(255,255,255,0.08);

	backdrop-filter: blur(12px);

	border-radius: 30px;

	padding: 1.3rem;

	${({ feedbackState }) => {

		if (feedbackState === "fail") {

			return css`
				animation: ${shake} 0.45s;
			`;
		}

		if (feedbackState === "success") {

			return css`
				animation: ${glowSuccess} 0.8s;
			`;
		}

		return css`
			animation: ${fadeUp} 0.45s;
		`;
	}}

	@media (max-width: 768px) {

		padding: 1.2rem;

		border-radius: 24px;
	}
`;

const Titulo = styled.h1`
	font-size: clamp(1.8rem, 5vw, 3rem);
	margin-bottom: 0.7rem;
`;

const Subtitulo = styled.p`
	color: rgba(255,255,255,0.65);

	font-size: 0.95rem;

	line-height: 1.45;

	margin-bottom: 1rem;
`;

const Imagen = styled.img`
	width: 100%;

	max-height: 180px;

	object-fit: contain;

	border-radius: 20px;

	margin-bottom: 1rem;

	cursor: ${({ bloqueado }) =>
		bloqueado
			? "not-allowed"
			: "zoom-in"};

	opacity:
		${({ bloqueado }) =>
			bloqueado ? 0.4 : 1};

	border:
		1px solid
		rgba(255,255,255,0.08);

	user-select: none;
`;

const Opciones = styled.div`

	display: grid;

	grid-template-columns: repeat(2, 1fr);

	gap: 1rem;

	margin-top: 1.5rem;

	@media (max-width: 768px) {

		grid-template-columns: 1fr;
	}
`;

const Opcion = styled.div`

	position: relative;

	backdrop-filter: blur(6px);

	overflow: hidden;
	
	min-height: 110px;

	display: flex;

	align-items: center;

	justify-content: center;

	transition:
		transform .2s ease,
		box-shadow .2s ease,
		border-color .2s ease;

	&:hover {

		background:
			rgba(91,105,226,.10);

		transform: translateY(-4px);

		box-shadow:
			0 12px 24px rgba(91,105,226,.25);
	}
	border: 2px solid
		${({ correcta, seleccionada, verRespuesta }) =>
			verRespuesta && correcta
				? "#22c55e"
				: seleccionada
				? "#5b69e2"
				: "rgba(255,255,255,0.08)"};

	background:
		${({ correcta, seleccionada, verRespuesta }) =>
			verRespuesta && correcta
				? "rgba(34,197,94,0.18)"
				: seleccionada
				? "rgba(91,105,226,0.18)"
				: "rgba(255,255,255,0.04)"};

	padding: 1.2rem;
	border-radius: 22px;

	cursor: ${({ verRespuesta }) =>
		verRespuesta ? "default" : "pointer"};
		pointer-events: ${({ verRespuesta }) =>
		verRespuesta ? "none" : "auto"};	

	&:hover {
		transform: ${({ verRespuesta }) =>
			verRespuesta ? "none" : "translateY(-2px)"};

		border-color: ${({ verRespuesta }) =>
			verRespuesta ? "" : "#5b69e2"};
	}
`;

const OpcionHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 0.8rem;
	margin-bottom: 0.7rem;
`;

const Letra = styled.div`
	width: 40px;
	height: 40px;
	border-radius: 12px;
	background: rgba(255,255,255,0.08);

	display: flex;
	align-items: center;
	justify-content: center;

	font-weight: 800;
`;

const TextoOpcion = styled.div`
	font-weight: 700;
`;

const Controles = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 1rem;
	margin-top: 1.2rem;

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
	position: sticky;

	bottom: 12px;

	z-index: 150;

	background: rgba(10,15,30,.78);

	backdrop-filter: blur(12px);

	padding: 0.8rem;

	border-radius: 24px;
`;

const Boton = styled.button`
	background: ${({ secundario }) =>
		secundario
			? "rgba(255,255,255,0.08)"
			: "linear-gradient(135deg, #5b69e2, #7c3aed)"};

	border: ${({ secundario }) =>
		secundario
			? "1px solid rgba(255,255,255,0.08)"
			: "none"};

	color: white;

	padding: 1rem;

	border-radius: 18px;

	font-size: 1rem;

	font-weight: 700;

	letter-spacing: 0.3px;

	cursor: pointer;

	min-height: 64px;

	transition: 0.25s ease all;

	opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

	&:hover {

		filter: brightness(1.08);

		transform: ${({ disabled }) =>
			disabled ? "none" : "translateY(-2px)"};

		box-shadow: ${({ disabled }) =>
			disabled
				? "none"
				: "0 10px 25px rgba(91,105,226,0.35)"};
	}
`;

const Resultado = styled.div`
	margin-top: 2rem;
	padding: 1.5rem;
	border-radius: 24px;

	background:
		${({ correcto }) =>
			correcto
				? "rgba(34,197,94,0.15)"
				: "rgba(239,68,68,0.15)"};

	border: 1px solid
		${({ correcto }) =>
			correcto
				? "rgba(34,197,94,0.3)"
				: "rgba(239,68,68,0.3)"};
`;

const ResultadoTitulo = styled.h2`
	font-size: 1.5rem;
	margin-bottom: 1rem;
`;

const Modal = styled.div`
	position: fixed;
	inset: 0;
	background: rgba(0,0,0,0.96);
	z-index: 999;

	display: flex;
	align-items: center;
	justify-content: center;

	padding: 2rem;
`;

const ModalContenido = styled.div`
	position: relative;
	max-width: 95vw;
	max-height: 95vh;
`;

const ModalImagen = styled.img`
	max-height: 85vh;
	max-width: 95vw;

	user-select: none;

	transform: ${({ x, y, zoom }) =>
		`translate(${x}px, ${y}px) scale(${zoom})`};

	transition: 0.2s ease;
`;

const CloseBtn = styled.button`
	position: absolute;
	top: -50px;
	right: 0;

	background: rgba(255,255,255,0.12);

	border: none;

	width: 42px;
	height: 42px;

	border-radius: 12px;

	color: white;

	font-size: 1.1rem;

	cursor: pointer;
`;

const NavModal = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1rem;

	margin-top: 1rem;
`;

const SmallBtn = styled.button`
	background: rgba(255,255,255,0.08);
	border: 1px solid rgba(255,255,255,0.08);

	color: white;

	padding: 0.8rem 1rem;

	border-radius: 14px;

	cursor: pointer;
`;

const Loader = styled.div`
	min-height: 100vh;

	display: flex;
	align-items: center;
	justify-content: center;

	color: white;
	font-size: 1.2rem;
`;

const LevelOverlay = styled.div`
	position: fixed;
	inset: 0;

	z-index: 5000;

	display: flex;
	align-items: center;
	justify-content: center;

	background:
		radial-gradient(
			circle,
			rgba(124,58,237,0.35),
			rgba(0,0,0,0.92)
		);

	backdrop-filter: blur(8px);

	animation: ${glowAnim} 0.4s ease;
`;

const LevelCard = styled.div`
	text-align: center;

	animation: ${levelAnim} 0.7s ease;
`;

const LevelTitle = styled.h1`
	font-size: clamp(3rem, 10vw, 7rem);

	font-weight: 900;

	margin-bottom: 1rem;

	background: linear-gradient(
		90deg,
		#ffffff,
		#c4b5fd,
		#7c3aed
	);

	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;

	text-shadow:
		0 0 40px rgba(124,58,237,0.5);
`;

const LevelSubtitle = styled.div`
	font-size: 1.5rem;
	font-weight: 700;

	color: white;

	margin-bottom: 1rem;
`;

const LevelRango = styled.div`
	font-size: 1.2rem;

	color: #c4b5fd;
`;

const ParticleContainer = styled.div`
	position: absolute;
	inset: 0;

	overflow: hidden;

	pointer-events: none;
`;

const Particle = styled.div`
	position: absolute;

	width: 12px;
	height: 12px;

	border-radius: 999px;

	background: rgba(255,255,255,0.8);

	left: ${({ left }) => left}%;
	top: ${({ top }) => top}%;

	animation:
		floatParticle ${({ duration }) => duration}s linear infinite;

	@keyframes floatParticle {

		0% {
			transform:
				translateY(0)
				scale(0.8);

			opacity: 0;
		}

		20% {
			opacity: 1;
		}

		100% {
			transform:
				translateY(-120vh)
				scale(1.5);

			opacity: 0;
		}
	}
`;

const FloatingXp = styled.div`
	position: fixed;

	left: 50%;
	top: 45%;

	transform: translateX(-50%);

	z-index: 6000;

	font-size: 3rem;
	font-weight: 900;

	color: #22c55e;

	text-shadow:
		0 0 20px rgba(34,197,94,0.8);

	pointer-events: none;

	animation:
		${floatXp} 1.8s ease forwards;
`;

const SummaryOverlay = styled.div`
	position: fixed;
	inset: 0;

	background:
		rgba(0,0,0,0.92);

	z-index: 8000;

	display: flex;
	align-items: center;
	justify-content: center;

	padding: 1rem;

	backdrop-filter: blur(8px);
`;

const LevelUpOverlay = styled.div`

	position: fixed;

	inset: 0;

	z-index: 9500;

	display: flex;

	align-items: center;

	justify-content: center;

	background:
		radial-gradient(
			circle,
			rgba(250,204,21,.18),
			rgba(0,0,0,.92)
		);

	backdrop-filter: blur(10px);

	animation:
		${fadeUp} .5s ease;
`;

const LevelUpCard = styled.div`

	width: 90%;
	max-width: 520px;

	padding: 3rem 2rem;

	border-radius: 36px;

	text-align: center;

	background:
		linear-gradient(
			145deg,
			rgba(255,255,255,0.10),
			rgba(255,255,255,0.04)
		);

	border:
		1px solid rgba(250,204,21,.35);

	box-shadow:
		0 0 80px rgba(250,204,21,.25);

	backdrop-filter: blur(18px);

	animation:
		${pulse} 2s infinite;
`;

const LevelUpTitle = styled.h1`

	font-size:
		clamp(2.5rem, 10vw, 4rem);

	font-weight: 900;

	margin-bottom: 1rem;

	background:
		linear-gradient(
			135deg,
			#facc15,
			#fb7185
		);

	-webkit-background-clip: text;

	-webkit-text-fill-color: transparent;
`;

const LevelUpText = styled.p`

	color: rgba(255,255,255,0.72);

	font-size: 1.1rem;

	line-height: 1.6;

	margin-top: 1rem;
`;

const SummaryCard = styled.div`
	width: 100%;
	max-width: 700px;

	max-height: 90vh;

	overflow-y: auto;

	scrollbar-width: none;

	padding: 2rem;

	border-radius: 34px;

	background:
		linear-gradient(
			145deg,
			rgba(255,255,255,0.08),
			rgba(255,255,255,0.03)
		);

	border:
		1px solid rgba(255,255,255,0.08);

	backdrop-filter: blur(18px);

	box-shadow:
		0 20px 80px rgba(0,0,0,.45);
`;

const SummaryTitle = styled.h1`
	font-size: 2.5rem;
	font-weight: 900;

	margin-bottom: 1.5rem;

	text-align: center;
`;

const SummaryXp = styled.div`

	font-size:
		clamp(2.2rem, 8vw, 3.2rem);

	font-weight: 900;

	text-align: center;

	margin-top: 1rem;

	margin-bottom: 1.5rem;

	background:
		linear-gradient(
			135deg,
			#facc15,
			#fb7185
		);

	-webkit-background-clip: text;

	-webkit-text-fill-color: transparent;

	text-shadow:
		0 0 30px rgba(250,204,21,.35);

	animation:
		${pulse} 1.8s infinite;
`;

const RewardBanner = styled.div`

	margin-top: 1.5rem;

	padding: 1rem;

	border-radius: 18px;

	text-align: center;

	font-weight: 700;

	background:
		rgba(250,204,21,.12);

	border:
		1px solid rgba(250,204,21,.25);

	color: #facc15;

	box-shadow:
		0 0 25px rgba(250,204,21,.08);
`;

const SummaryGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);

	gap: 1rem;

	margin-bottom: 2rem;

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;

const SummaryButtons = styled.div`

	display: grid;

	grid-template-columns:
		repeat(2, 1fr);

	gap: 1rem;

	margin-top: 2rem;

	@media (max-width: 768px) {

		grid-template-columns: 1fr;
	}
`;

const SummaryStat = styled.div`
	background:
		rgba(255,255,255,0.05);

	border:
		1px solid rgba(255,255,255,0.08);

	border-radius: 20px;

	padding: 1.2rem;

	transition:
	transform .2s ease,
	border-color .2s ease;

	&:hover {

		transform: translateY(-3px);

		border-color:
			rgba(91,105,226,.35);
	}
`;

const SummaryLabel = styled.div`
	font-size: 0.9rem;

	color: rgba(255,255,255,0.6);

	margin-bottom: 0.4rem;
`;

const SummaryValue = styled.div`
	font-size: 2rem;
	font-weight: 900;
`;

const LifeOverlay = styled.div`
	position: fixed;
	inset: 0;

	background:
		rgba(0,0,0,0.92);

	z-index: 8500;

	display: flex;
	align-items: center;
	justify-content: center;

	padding: 2rem;
`;

const LifeCard = styled.div`
	max-width: 500px;
	width: 100%;

	background:
		linear-gradient(
			145deg,
			rgba(239,68,68,0.12),
			rgba(255,255,255,0.03)
		);

	border:
		1px solid rgba(239,68,68,0.3);

	border-radius: 30px;

	padding: 2rem;

	text-align: center;

	color: white;
`;

const RenderContenido = ({
	texto,
	latex
  }) => {
  
	return (
	  <>
		{texto && (
		  <div
			style={{
			  fontSize: "1.05rem",
			  lineHeight: "1.7",
			  marginBottom: "1rem",
			  whiteSpace: "pre-wrap"
			}}
		  >
			{texto}
		  </div>
		)}
  
		{latex && (
		  <div
			style={{
			  fontSize: "1.3rem",
			  marginBottom: "1rem"
			}}
		  >
			<InlineMath>
			  {latex}
			</InlineMath>
		  </div>
		)}
	  </>
	);
  };

// =========================
// COMPONENTE
// =========================

const Quiz = () => {

	const { tipo } = useParams();
	const location = useLocation();

	

	const searchParams =
	new URLSearchParams(
		location.search
	);

const componenteSimulacro =
	searchParams.get(
		"componente"
	);

const examenSimulacro =
	searchParams.get(
		"examen"
	);

	const temaObjetivo =
	searchParams.get(
		"tema"
	);	

	const esSimulacro =
    tipo === "simulacro" &&
    !temaObjetivo;

	console.log("TIPO QUIZ:", tipo);
	const { usuario } = useAuth();

	const tipoValido = tipo || "Examen_Icfes";

	const [preguntas, setPreguntas] = useState([]);
	const [preguntaActual, setPreguntaActual] = useState(null);
	const [historial, setHistorial] = useState([]);

	const [seleccion, setSeleccion] = useState(null);
	const [verRespuesta, setVerRespuesta] = useState(false);
	const [tiempoPregunta, setTiempoPregunta] = useState(0);

const [cronometroActivo, setCronometroActivo] =
    useState(true);

	const [cronometroWarning, setCronometroWarning] =
    useState(false);

const [cronometroDanger, setCronometroDanger] =
    useState(false);
// =========================
// UTILIDADES
// =========================
	const tiempoFormateado = () => {

		const minutos =
			Math.floor(tiempoPregunta / 60);
	
		const segundos =
			tiempoPregunta % 60;
	
		return `${String(minutos).padStart(2,"0")}:${String(segundos).padStart(2,"0")}`;
	
	};
	const [hud, setHud] = useState({
		streak: 0,
		yutokens: 0,
		multiplier: 1,
		corrupcion: 0,
		nivel: 1,
		xp: 0,
		xpMax: 100,
		rankedLp: 0,
		rankedRango: "Hierro",
	
		vidas: 5,
		vidasMax: 5,
	
		rango: {
			nombre: "Hierro",
			color: "#6b7280",
			icono: "🪨"
		}
	});

	const [levelUpData, setLevelUpData] = useState(null);
	const [feedbackState, setFeedbackState] = useState(null);
const [floatingXp, setFloatingXp] = useState(null);
	const [promo, setPromo] = useState({
		activa: false,
		wins: 0,
		losses: 0,
		target: "Oro"
	});

	const [imagenes, setImagenes] = useState({
		enunciado: [],
		q: [],
		a: [],
		b: [],
		c: [],
		d: [],
		r: [],
	});

	const [membresia, setMembresia] = useState(null);

	const [modalImagenes, setModalImagenes] = useState([]);
	const [modalIndex, setModalIndex] = useState(0);

	const [zoom, setZoom] = useState(1);
	const [pos, setPos] = useState({ x: 0, y: 0 });
	const [mostrarLevelUp, setMostrarLevelUp] =
		useState(false);

	const dragging = useRef(false);
	const start = useRef({ x: 0, y: 0 });

	const touchStartX = useRef(0);

	const botonContinuarRef = useRef(null);

	const [sessionId] = useState(() => crypto.randomUUID());

	const [sessionStats, setSessionStats] = useState({
		correctas: 0,
		incorrectas: 0,
		neutras: 0,
		xpGanada: 0,
		inicio: Date.now()
	});

	const [evaluacionTema,setEvaluacionTema]=
useState(null);

const [resultadoSesion, setResultadoSesion] =
useState(null);
	
	const [mostrarResumen, setMostrarResumen] =
		useState(false);

		const [confirmarRespuesta, setConfirmarRespuesta] =
		useState(false);	

		const [procesando, setProcesando] =
    useState(false);

		const [preguntasObjetivo, setPreguntasObjetivo] =
		useState(null);
	
	const [preguntasRespondidas, setPreguntasRespondidas] =
		useState(0);
		
		const [versionSimulacro, setVersionSimulacro] =
		useState(1);	
	// =========================
	// MEMBRESÍA + PROGRESO
	// =========================

	useEffect(() => {

		const cargar = async () => {

			if (!usuario) return;

			// Membresía
			const data = await obtenerMembresiaActiva(
				usuario.uid
			);

			console.log(
				"MEMBRESIA COMPLETA:",
				data
			  );

			setMembresia(data);

			// Progreso
			const progreso =
				await obtenerProgresoUsuario(
					usuario.uid
				);

			if (progreso) {

				setHud((prev) => ({
					...prev,

					xp: progreso.xpActual || 0,

					xpMax: progreso.xpMax || 100,

					streak: progreso.streak || 0,

					multiplier:
						progreso.multiplier || 1,

					corrupcion:
						progreso.corrupcion || 0,

					nivel: progreso.nivel || 1,

					rango: obtenerRango(
						progreso.xpTotal || 0
					)
				}));
			}
		};

		cargar();

	}, [usuario]);

	const features = membresia?.plan?.features || {};

	console.log("FEATURES:", features);
console.log(
  "VER_RESPUESTAS:",
  features?.ver_respuestas
);
	// =========================
	// CARGAR PREGUNTAS
	// =========================

	useEffect(() => {

		const cargar = async () => {

			console.count("🔥 DESCARGANDO TODAS LAS PREGUNTAS");

			const snap = await getDocs(collection(db, "preguntas"));

			console.log("Preguntas descargadas:", snap.size);

			const data = snap.docs
	.map((d) => {

		const pregunta = d.data();

					if (
						String(d.id) !==
						String(pregunta.ID)
					) {

						console.error(
							"❌ ID FIRESTORE ≠ ID CAMPO",
							{
								docId: d.id,
								idCampo: pregunta.ID
							}
						);

						return null;
					}

					return pregunta;
				})
				.filter(Boolean);

			const filtros = filtrosExamen[tipoValido];

			const filtradas = filtros
				? data.filter((p) => filtros.includes(p.Examenes))
				: data;

				let preguntasFinales =
				filtradas;

				if (temaObjetivo) {

					preguntasFinales =
						preguntasFinales.filter(
							p =>
								[
									p.Tema1,
									p.Tema2,
									p.Tema3,
									p.Tema4
								]
								.map(Number)
								.includes(
									Number(
										temaObjetivo
									)
								)
						);
				
					console.log(
						"🎯 ENTRENANDO TEMA:",
						temaObjetivo,
						preguntasFinales.length
					);
				}
				
				if (
					esSimulacro &&
					componenteSimulacro
				) {
				
					const temaCompSnap =
						await getDocs(
							collection(
								db,
								"tema_componente"
							)
						);

						const componenteSnap =
						await getDocs(
							collection(
								db,
								"componentes"
							)
						);
						
						

					const componenteActual =
						componenteSnap.docs
							.map(d => d.data())
							.find(
								c =>
									Number(c.ID) ===
									Number(componenteSimulacro)
							);
					
							if (componenteActual) {

								setPreguntasObjetivo(
									Number(
										componenteActual.PreguntasSimulacro || 20
									)
								);
							
								setVersionSimulacro(
									Number(
										componenteActual.VersionSimulacro || 1
									)
								);
							}
					
					console.log(
						"PREGUNTAS OBJETIVO:",
						componenteActual?.PreguntasSimulacro
					);
				
					const relaciones =
						temaCompSnap.docs.map(
							d => d.data()
						);
				
					preguntasFinales =
						generarPoolPreguntas(
							filtradas,
							componenteSimulacro,
							relaciones
						);
				
					console.log(
						"SIMULACRO",
						componenteSimulacro
					);
				
					console.log(
						"PREGUNTAS FILTRADAS",
						preguntasFinales.length
					);
				}

			if (filtradas.length === 0) return;

			setPreguntas(
				preguntasFinales
			);
			
			const inicial =
				motorPreguntas({
			
					preguntas:
						preguntasFinales,
			
					modo:
						esSimulacro
							? "simulacro"
							: "libre"
				});

			setPreguntaActual(inicial);

			console.log(
				"PREGUNTA ACTUAL:",
				inicial
			  );

			setHistorial([inicial]);
		};

		cargar();

	}, [
		tipoValido,
		temaObjetivo,
		esSimulacro,
		componenteSimulacro,
		examenSimulacro
	]);

	// =========================
	// IMÁGENES
	// =========================

	useEffect(() => {

		const cargarImgs = async () => {

			if (!preguntaActual) return;

			const id = preguntaActual.ID;

			const base = `preguntas/${id}`;

			let enunciado = [];

			if (
				preguntaActual.EnunciadoID !== null &&
				preguntaActual.EnunciadoID !== undefined
			) {

				enunciado = await getImagenes(
					`enunciados/${preguntaActual.EnunciadoID}`,
					preguntaActual.enunciado_imgs || 0
				);
			}

			const q = await getImagenes(`${base}/q`, preguntaActual.q_imgs || 0);
			const a = await getImagenes(`${base}/a`, preguntaActual.a_imgs || 0);
			const b = await getImagenes(`${base}/b`, preguntaActual.b_imgs || 0);
			const c = await getImagenes(`${base}/c`, preguntaActual.c_imgs || 0);
			const d = await getImagenes(`${base}/d`, preguntaActual.d_imgs || 0);
			const r = await getImagenes(`${base}/r`, preguntaActual.r_imgs || 0);

			setImagenes({
				enunciado,
				q,
				a,
				b,
				c,
				d,
				r,
			});
		};

		if (preguntaActual) {

			registrarEvento({
				session_id: sessionId,
				evento: "ver_pregunta",
				pregunta: preguntaActual,
			});
		}

		cargarImgs();

	}, [preguntaActual, sessionId]);

	// =========================
// CRONÓMETRO
// =========================

useEffect(() => {

    if (!cronometroActivo)
        return;

    const intervalo = setInterval(() => {

        setTiempoPregunta(prev => {

			const nuevo = prev + 1;
		
			if (nuevo >= 300) {
		
				setCronometroWarning(true);
		
			}
		
			if (nuevo >= 600) {
		
				setCronometroDanger(true);
		
			}
		
			return nuevo;
		
		});

    },1000);

    return () => clearInterval(intervalo);

}, [cronometroActivo]);

useEffect(() => {

    const beforeUnload = (e) => {

        if (!mostrarResumen) {

            e.preventDefault();

            e.returnValue = "";

        }

    };

    window.addEventListener(
        "beforeunload",
        beforeUnload
    );

    return () => {

        window.removeEventListener(
            "beforeunload",
            beforeUnload
        );

    };

}, [mostrarResumen]);
	// =========================
	// SELECCIÓN
	// =========================

	const seleccionar = (op) => {

		if (verRespuesta) return;

		setSeleccion(op);

		registrarEvento({
			session_id: sessionId,
			evento: "seleccionar_opcion",
			pregunta: preguntaActual,
			opcion: op,
		});
	};

	const actualizarHud = (progreso, perderVida = false) => {

		setHud(prev => ({
	
			...prev,
	
			yutokens: progreso.yutokens,
	
			rankedLp: progreso.rankedLp,
	
			rankedRango: progreso.rankedRango,
	
			rango: obtenerRango(progreso.rankedLp),
	
			xp: progreso.xpActual,
	
			xpMax: progreso.xpMax,
	
			streak: progreso.streak,
	
			multiplier: progreso.multiplier,
	
			corrupcion: progreso.corrupcion,
	
			nivel: progreso.nuevoNivel,
	
			vidas: perderVida
				? Math.max(prev.vidas - 1,0)
				: prev.vidas
	
		}));
	
	};
// ====================================
// MOTOR DE CIERRE DE PREGUNTA
// ====================================
//
// Esta función será el único punto que:
//
// - valida la respuesta
// - actualiza progreso
// - actualiza HUD
// - actualiza estadísticas
// - dispara animaciones
// - registra eventos
//
// Tanto Quiz como Simulacro deberán
// utilizar este mismo motor.
//
// ==========================================
// MOTOR PRINCIPAL DEL QUIZ
//
// TODO:
// Renombrar a cerrarPregunta()
// Será utilizado por:
//
// • Quiz normal
// • Simulacro
// • Quiz por componente
// • Modos futuros
//
// Debe contener TODA la lógica de:
//
// - validación
// - progreso
// - HUD
// - XP
// - achievements
// - estadísticas
// - analytics
//
// NO debe encargarse de navegar.
// ==========================================

const cerrarPregunta = async () => {

    if (verRespuesta) return;

    if (!seleccion) return;

	if (procesando) return;


		console.log(
			"=== CERRANDO PREGUNTA ==="
		);
		
		console.log(
			"Modo:",
			esSimulacro
				? "SIMULACRO"
				: "QUIZ"
		);

		

		console.log({
			seleccion,
			correcta
		});

		const resultado =
    seleccion === "ni"
        ? null
        : seleccion?.toLowerCase() === correcta;
		let progreso = null;
// TODO
// Será utilizado por el cronómetro
// y replay del quiz.
// TODO
// Será enviado al motor unificado
// de procesamiento.

		setVerRespuesta(true);
		setTimeout(() => {

			botonContinuarRef.current?.focus();
		
		}, 50);
		detenerCronometro();
		
		console.log({
			tiempoPregunta,
			warning: cronometroWarning,
			danger: cronometroDanger
		});
		// =========================
// PROCESAMIENTO CENTRAL
// =========================

		if (usuario) {
		
			try {
// TODO
// Reemplazar por modo DEBUG global.
				console.log("=== DEBUG QUIZ ===");
			
				console.log("preguntaActual:");
				console.log(preguntaActual);
			
				console.log("Respuesta raw:");
				console.log(
					preguntaActual?.Respuesta
				);
			
				console.log("correcta:");
				console.log(correcta);
			
				console.log("seleccion:");
				console.log(seleccion);
			
				console.log("resultado:");
				console.log(resultado);
			
				progreso =
await actualizarProgresoMeta({

    userId: usuario.uid,

    metaId:
        esSimulacro
            ? examenSimulacro
            : metaMap[tipoValido],

    correcta: resultado,

    pregunta: {

        ...preguntaActual,

		componenteId:

    componenteSimulacro

    ??

    null,

        tiempoRespuesta:
            tiempoPregunta,

        modo:
            esSimulacro
                ? "simulacro"
                : "quiz",

        origen:
            tipoValido,

        sesionId:
            sessionId

    }

	

});

if (progreso?.evaluacionTema) {

    setEvaluacionTema(

        progreso.evaluacionTema

    );

}

setResultadoSesion(progreso);
			
				console.log("PROGRESO:");
				console.log(progreso);
			
			} catch(error) {
			
				console.error(
					"ERROR HANDLEVERRESPUESTA"
				);
			
				console.error(error);
			}
			if (!progreso) {

				setVerRespuesta(false);
			
				iniciarCronometro();
			
				toast.error("No fue posible guardar el progreso.");
			
				return;
			
			}
		}
		// =========================
// TODO
// Unificar actualización HUD
// Actualmente existen varias
// actualizaciones repetidas.
// =========================
// TODO SPRINT 3:
// Unificar actualización HUD

actualizarHud(progreso);

		// =========================
// ESTADÍSTICAS DE SESIÓN
// =========================

		setSessionStats((prev) => {

			const nuevas = { ...prev };
		
			if (resultado === true) {
		
				nuevas.correctas += 1;
		
			} else if (resultado === false) {
		
				nuevas.incorrectas += 1;
		
			} else {
		
				nuevas.neutras += 1;
			}
		
			nuevas.xpGanada +=
				progreso?.xpGanada || 0;
		
				
				return nuevas;


		});

		// =====================================
// TODO
// La finalización del simulacro será
// responsabilidad exclusiva de
// siguiente().
//
// cerrarPregunta() solamente procesa
// la pregunta.
// =====================================

		

		if (progreso) {
		
			if (progreso.tipo === "correcta") {

				if (progreso.subioNivel) {

					setMostrarLevelUp(true);
				
					setTimeout(() => {
				
						setMostrarLevelUp(false);
				
					}, 3200);
				}

				// TODO
// Este bloque podrá unificarse con el
// anterior cuando terminemos la
// refactorización del motor.
// TODO SPRINT 3:
// Unificar actualización HUD
				
				console.log(
					"ANIMACIÓN SUCCESS"
				);

				setFeedbackState("success");
				// TODO
// Vibración correcta
				navigator.vibrate?.(60);

				setFloatingXp(
					`⚡ +${progreso.xpFinal} XP · COMBO`
				);

				setTimeout(() => {

					setFloatingXp(null);

				}, 1800);

				setTimeout(() => {

					setFeedbackState(null);

				}, 700);		
				toast.success(

					progreso.multiplier > 1
				
					? `🔥 x${progreso.multiplier} COMBO · +${progreso.xpFinal} XP`
				
					: `+${progreso.xpFinal} XP ⚡ · Racha x${progreso.streak}`
				
				);		
			} else if (progreso.tipo === "incorrecta") {
		// TODO
// Última actualización repetida del HUD.
// Se eliminará al finalizar el sprint.
// TODO SPRINT 3:
// Unificar actualización HUD
				console.log(
					"FAIL XP"
				);
				toast.error(
					`Corrupción ${progreso.corrupcion}% ☣️`
				);
		
			} else {
		
				
				console.log(
					"NO ENTIENDE"
				);
				toast(
					`+${progreso.xpGanada} XP 🧠 Sigue explorando`
				);
			}
		// TODO
// Este setHud también podrá
// integrarse al bloque principal.
			if (progreso.subioNivel) {
		// TODO SPRINT 3:
// Unificar actualización HUD

				setLevelUpData({
					nivel: progreso.nuevoNivel,
					rango: progreso.nuevoRango
				});
				
				setTimeout(() => {
				
					setLevelUpData(null);
				
				}, 3500);
			}

			if (
				!promo.activa &&
				progreso.xpTotal >= 850 &&
				hud.rango.nombre === "Plata"
			) {
			
				setPromo({
					activa: true,
					wins: 0,
					losses: 0,
					target: "Oro"
				});
			
				console.log(
					"SUCCESS XP"
				);
				toast.success(
					"🔥 PROMOCIÓN A ORO INICIADA",
					{
						duration: 5000
					}
				);
			}

			if (promo.activa) {

				let wins = promo.wins;
				let losses = promo.losses;
			
				if (resultado === true) {
					wins += 1;
				}
			
				if (resultado === false) {
					losses += 1;
				}
			
				setPromo({
					...promo,
					wins,
					losses
				});
			
				if (wins >= 2) {
			
					toast.success(
						"🏆 ASCENDISTE A ORO",
						{
							duration: 6000
						}
					);
			
					setPromo({
						activa: false,
						wins: 0,
						losses: 0,
						target: ""
					});
				}
			
				if (losses >= 2) {
					console.log(
						"ANIMACIÓN FAIL"
					);
					setFeedbackState("fail");
					// TODO
// Vibración promoción fallida
					navigator.vibrate?.([80, 40, 80]);

					setTimeout(() => {

						setFeedbackState(null);

					}, 700);
					toast.error(
						"💀 PROMOCIÓN FALLIDA",
						{
							duration: 6000
						}
					);
			
					setPromo({
						activa: false,
						wins: 0,
						losses: 0,
						target: ""
					});
				}
			}

			if (
				progreso.achievements?.length > 0
			) {
			
				progreso.achievements.forEach(
					(a, index) => {
			
						setTimeout(() => {
			
							toast.success(
								`${a.icono} LOGRO DESBLOQUEADO: ${a.titulo}`,
								{
									duration: 5000
								}
							);
			
						}, index * 800);
					}
				);
			}

			if (
				progreso.dailyQuests?.length > 0
			) {
			
				progreso.dailyQuests.forEach(
					(q, index) => {
			
						setTimeout(() => {
			
							toast.success(
								`🗓️ MISIÓN COMPLETADA: ${q.titulo} · +${q.xp} XP`,
								{
									duration: 6000
								}
							);
			
						}, index * 1200);
					}
				);
			}
		}

		
		registrarEvento({
			session_id: sessionId,
			evento: "ver_respuesta",
			pregunta: preguntaActual,
			opcion: seleccion,
		});

		// El procesamiento termina aquí.
// La navegación deberá ejecutarse
// desde la función que invoque este motor.



return {
			resultado,
			progreso
		};


	};

	const prepararNuevaPregunta = () => {

		setSeleccion(null);
	
		setVerRespuesta(false);
	
		detenerCronometro();

setTiempoPregunta(0);

setCronometroWarning(false);

setCronometroDanger(false);

iniciarCronometro();
	
	};
	// =========================
	// NAVEGACIÓN
	// =========================

	const siguiente = async () => {

		if (procesando) return;

		setMostrarResumen(false);
	
		setProcesando(true);

		
		console.log(
			"=== SIGUIENTE PREGUNTA ==="
		);

		if (
			!verRespuesta &&
			seleccion
		) {
		
			console.log(
				"Cerrando automáticamente la pregunta..."
			);
		
			await cerrarPregunta();
		}
		
		console.log(
			"Modo:",
			esSimulacro
				? "SIMULACRO"
				: "QUIZ"
		);
		
		console.log(
			"verRespuesta:",
			verRespuesta
		);

		if (esSimulacro) {

			console.log(
				"SIMULACRO -> siguiente()"
			);
			
			console.log({
				seleccion,
				verRespuesta,
				sessionStats
			});
	
			const nuevasRespondidas =
				preguntasRespondidas + 1;

				console.log({
					nuevasRespondidas,
					sessionStats,
					preguntasObjetivo
				});
	
			setPreguntasRespondidas(
				nuevasRespondidas
			);
	
			console.log(
				"RESPONDIDAS:",
				nuevasRespondidas
			);
	
			if (
				preguntasObjetivo &&
				nuevasRespondidas >= preguntasObjetivo
			) {
	
				console.log(
					"SIMULACRO COMPLETADO"
				);
	
				try {
	
					await addDoc(
						collection(
							db,
							"simulacros_componentes"
						),
						{
							userId:
								usuario.uid,
	
							examen:
								examenSimulacro,
	
							componente:
								Number(
									componenteSimulacro
								),
	
							version:
								versionSimulacro,
	
							preguntasObjetivo,
	
							correctas:
								sessionStats.correctas,
	
							incorrectas:
								sessionStats.incorrectas,
	
							neutras:
								sessionStats.neutras,
	
							fecha:
								serverTimestamp()
						}
					);
	
					await setDoc(
						doc(
							db,
							"progreso_metas",
							`${usuario.uid}_${examenSimulacro}_${componenteSimulacro}`
						),
						{
							userId:
								usuario.uid,
	
							examen:
								examenSimulacro,
	
							componente:
								Number(
									componenteSimulacro
								),
	
							simulacroCompletado:
								true,
	
							versionCompletada:
								versionSimulacro,
	
							fechaPrimerSimulacro:
								serverTimestamp()
						},
						{
							merge: true
						}
					);

					const componentes =

    await calcularComponentesExamen(

        usuario.uid

    );

	const carrerasSnap =
    await getDocs(
        collection(
            db,
            "carreras"
        )
    );

const carreras =
    carrerasSnap.docs.map(
        d => d.data()
    );

	for (const examenId of Object.keys(componentes)) {

		const examen = componentes[examenId];
	
		for (const componente of Object.values(examen.componentes)) {
	
			await addDoc(
	
				collection(
	
					db,
	
					"historial_componentes"
	
				),
	
				{
	
					userId:
	
						usuario.uid,
	
					examenId:
	
						Number(examenId),
	
					componenteId:
	
						componente.id,
	
					fecha:
	
						serverTimestamp(),
	
					dominio:
	
						componente.dominio,
	
					estado:
	
						componente.estado,
	
					temasExplorados:
	
						componente.temasExplorados,
	
					temasEvaluados:
	
						componente.temasEvaluados
	
				}
	
			);
	
		}
	
	}

	let totalComponentes = 0;

let sumaDominios = 0;

let componentesEvaluados = 0;

let componentesDominados = 0;

let componentesEstables = 0;

let componentesCriticos = 0;

for (const examenId of Object.keys(componentes)) {

    const examen = componentes[examenId];

    Object.values(
        examen.componentes
    ).forEach(comp => {

        totalComponentes++;

        if (comp.dominio !== null) {

            sumaDominios += comp.dominio;

            componentesEvaluados++;

        }

        if (comp.estado === "dominado") {

            componentesDominados++;

        }

        if (comp.estado === "estable") {

            componentesEstables++;

        }

        if (comp.estado === "critico") {

            componentesCriticos++;

        }

    });

}

const dominioGeneral =

    componentesEvaluados === 0

        ? null

        : Math.round(

            sumaDominios /

            componentesEvaluados

        );

		for (const examenId of Object.keys(componentes)) {

			await addDoc(
		
				collection(
					db,
					"historial_examenes"
				),
		
				{
		
					userId: usuario.uid,
		
					examenId: Number(examenId),
		
					fecha: serverTimestamp(),
		
					dominio: dominioGeneral,
		
					componentes: totalComponentes,
		
					componentesEvaluados,
		
					componentesDominados,
		
					componentesEstables,
		
					componentesCriticos
		
				}
		
			);
		
		}




	
					console.log(
						"SIMULACRO GUARDADO"
					);
	
				} catch(error) {
	
					console.error(error);
				}

				console.log(
					"RESUMEN DESDE siguiente()",
					sessionStats
				);
	
				setMostrarResumen(true);

				setProcesando(false);
	
				return;
			}
		}
		
		console.log(
			"Generando siguiente pregunta..."
		);
		console.log(
			"Historial:",
			historial.length
		);

		// =========================
// NUEVA PREGUNTA
// =========================
const nueva =
motorPreguntas({
	preguntas,
	modo:
		esSimulacro
			? "simulacro"
			: "libre"
});

if (!nueva) {

    setMostrarResumen(true);

	setProcesando(false);

    return;

}

			
	
			console.log(
				"CAMBIANDO A NUEVA PREGUNTA:",
				nueva?.ID
			);	
			console.log(
				"Historial actualizado."
			);
			// Actualiza la pregunta actual
		setPreguntaActual(nueva);
	// Guarda navegación
		setHistorial((prev) => [
			...prev,
			nueva
		]);
	
		prepararNuevaPregunta();


		console.log(
			"Pregunta preparada."
		);

		setProcesando(false);
		console.log(
			"Cronómetro reiniciado."
		);


	};	
// TODO
// Extraer a resetPregunta().
// =========================
// HISTORIAL
// =========================
const volver = () => {

    if (procesando) return;

    if (historial.length <= 1) return;

		const nuevo = [...historial];

		nuevo.pop();

		const anterior = nuevo[nuevo.length - 1];

		setHistorial(nuevo);

		setPreguntaActual(anterior);

		setFeedbackState(null);

		setFloatingXp(null);

		prepararNuevaPregunta();
	};

	const detenerCronometro = () => {

		setCronometroActivo(false);
	
	};
	
	const iniciarCronometro = () => {

		setCronometroActivo(true);
	
	};

	// =========================
	// MODAL
	// =========================

	// =========================
// VISOR DE IMÁGENES
// =========================

	const abrirModal = (imgs, index = 0) => {

		if (!features.ver_imagenes) return;

		setModalImagenes(imgs);

		setModalIndex(index);

		setZoom(1);

		setPos({ x: 0, y: 0 });
	};

	const cerrarModal = () => {

		setModalImagenes([]);
	
		resetZoom();
	
	};

	const nextImg = () => {

		setModalIndex((i) => (i + 1) % modalImagenes.length);

		resetZoom();
	};

	const prevImg = () => {

		setModalIndex((i) =>
			i === 0
				? modalImagenes.length - 1
				: i - 1
		);

		resetZoom();
	};

	const resetZoom = () => {

		setZoom(1);

		setPos({ x: 0, y: 0 });
	};

	const abrirImagen = (imgs, index = 0) => {

		abrirModal(imgs, index);
	
	};

	const zoomIn = () => setZoom((z) => Math.min(z + 0.3, 4));

	const zoomOut = () => setZoom((z) => Math.max(z - 0.3, 1));

	// =========================
	// DRAG
	// =========================

	const handleMouseDown = (e) => {

		dragging.current = true;

		start.current = {
			x: e.clientX - pos.x,
			y: e.clientY - pos.y,
		};
	};

	const handleMouseMove = (e) => {

		if (!dragging.current) return;

		setPos({
			x: e.clientX - start.current.x,
			y: e.clientY - start.current.y,
		});
	};

	const handleMouseUp = () => {
		dragging.current = false;
	};

	// =========================
	// SWIPE
	// =========================

	const handleTouchStart = (e) => {
		touchStartX.current = e.touches[0].clientX;
	};

	const handleTouchEnd = (e) => {

		const diff =
			e.changedTouches[0].clientX -
			touchStartX.current;

		if (diff > 50) prevImg();

		if (diff < -50) nextImg();
	};

	console.log(
		"RENDER PREGUNTA:",
		preguntaActual
	  );

	if (!preguntaActual) {

		return (
			<Loader>
				Cargando preguntas...
			</Loader>
		);
	}
// =========================
// RESPUESTA CORRECTA
// =========================
	const correcta =
		String(
			preguntaActual?.Respuesta || ""
		)
		.trim()
		.toLowerCase();

		const esCorrecta =
    seleccion?.toLowerCase() === correcta;

		const preguntaId =
    preguntaActual?.ID;

		// TODO
// Será utilizado para aplicar
// estilos dinámicos al botón.

		const claseCronometro =
	cronometroDanger
		? "danger"
		: cronometroWarning
		? "warning"
		: "normal";

	return (
		<Contenedor>

			<Topbar>

				<BotonBack to="/">
					⬅ Volver al lobby
				</BotonBack>

				<HeaderInfo>

					<Badge>
						🎯 {tipoValido.replace("Examen_", "")}
					</Badge>

					<Badge>
					🧠 Pregunta #{preguntaId}
					</Badge>

				</HeaderInfo>

			</Topbar>

			<Hud>

				<HudItem>
					🧠 Nv {hud.nivel}
				</HudItem>

				<HudItem>
					⚡ {hud.xp}/{hud.xpMax}
				</HudItem>

				<HudItem>
					🔥 x{hud.streak}
				</HudItem>

				<HudItem>
				🏆 {hud.rankedLp} LP
				</HudItem>

				<HudItem>
					💰 {hud.yutokens}
				</HudItem>


				<HudItem
    style={{
        background:
            cronometroDanger
                ? "#8B0000"
                : cronometroWarning
                ? "#B8860B"
                : undefined,
        transition: ".3s"
    }}
>

⏱ {tiempoFormateado()}

</HudItem>

				<HudItem
					style={{
						color: hud.rango.color
					}}
				>

					{hud.rango.icono}
					{" "}
					{hud.rango.nombre}

				</HudItem>				

			</Hud>	

			{
    esSimulacro &&
    preguntasObjetivo && (

        <div
            style={{
                marginBottom: "1rem"
            }}
        >

            <div
                style={{
                    fontWeight: "bold",
                    marginBottom: ".5rem"
                }}
            >

                🧪 Simulacro

                {" "}

                {preguntasRespondidas}

                /

                {preguntasObjetivo}

            </div>

            <div
                style={{
                    height: "12px",
                    borderRadius: "999px",
                    overflow: "hidden",
                    background:
                        "rgba(255,255,255,.12)"
                }}
            >

                <div
                    style={{
                        height: "100%",
                        width: `${
                            (
                                preguntasRespondidas /
                                preguntasObjetivo
                            ) * 100
                        }%`,
                        background:
                            "linear-gradient(90deg,#00F2FF,#00FF95)"
                    }}
                />

            </div>

        </div>
    )
}		

			

			{promo.activa && (

			<PromoCard>

				<PromoTitle>
					🔥 PROMOCIÓN A {promo.target}
				</PromoTitle>

				<PromoCircles>

					{[0,1,2].map((i) => {

						let state = "empty";

						if (i < promo.wins) {
							state = "win";
						}

						if (
							i >= promo.wins &&
							i < promo.wins + promo.losses
						) {
							state = "loss";
						}

						return (
							<PromoCircle
								key={i}
								state={state}
							/>
						);
					})}

				</PromoCircles>

			</PromoCard>

			)}

			<MainCard
				key={preguntaActual?.ID}
				feedbackState={feedbackState}
				data-pregunta={preguntaId}
			>

				<Titulo>
				🎯 Desafío
				</Titulo>

				<Subtitulo>
					Selecciona la opción correcta y entrena
					tu velocidad mental como en un examen real.
				</Subtitulo>

				{/* ENUNCIADO */}

				<RenderContenido
  texto={
    preguntaActual?.pregunta_texto
  }
  latex={
    preguntaActual?.pregunta_latex
  }
/>

				{imagenes.enunciado?.map((img, i) => (
					<Imagen
						key={i}
						src={img}
						bloqueado={!features.ver_imagenes}
						onClick={() =>
							abrirImagen(imagenes.enunciado, i)
						}
					/>
				))}

				{/* PREGUNTA */}

				{imagenes.q?.map((img, i) => (
					<Imagen
						key={i}
						src={img}
						bloqueado={!features.ver_imagenes}
						onClick={() =>
							abrirImagen(imagenes.q, i)
						}
					/>
				))}

				{/* OPCIONES */}

				<Opciones>

					{["a", "b", "c", "d"].map((op) => (

						<Opcion
							key={op}
							onClick={() => seleccionar(op)}
							seleccionada={seleccion === op}
							correcta={op === correcta}
							verRespuesta={verRespuesta}
						>

							<OpcionHeader>

								<Letra>
									{op.toUpperCase()}
								</Letra>


							</OpcionHeader>

							<RenderContenido
  texto={
    preguntaActual?.[
      `${op}_texto`
    ]
  }
  latex={
    preguntaActual?.[
      `${op}_latex`
    ]
  }
/>

							{imagenes[op]?.map((img, i) => (
								<Imagen
									key={i}
									src={img}
									bloqueado={!features.ver_imagenes}
									onClick={(e) => {
										e.stopPropagation();

										abrirImagen(imagenes[op], i);
									}}
								/>
							))}

						</Opcion>
					))}

					<Opcion
						onClick={() => seleccionar("ni")}
						seleccionada={seleccion === "ni"}
					>

						<TextoOpcion>
							🤯 No entiendo esta pregunta
						</TextoOpcion>

					</Opcion>

				</Opciones>

				<Controles>

				{
    !esSimulacro && (

        <Boton
            title="Detener cronómetro"
            onClick={() => setConfirmarRespuesta(true)}
            disabled={
				mostrarResumen ||
				!seleccion ||
				verRespuesta ||
				!features.ver_respuestas ||
				hud.vidas <= 0
			}
        >

            {hud.vidas <= 0
                ? "💔 Sin vidas"
                : features.ver_respuestas
                ? `⏱ ${tiempoFormateado()}`
                : "🔒 Plan premium requerido"}

        </Boton>

    )
}

{
    !esSimulacro && (

        <Boton
    secundario
    onClick={volver}
    disabled={procesando}
>

            📖 Revisar anterior

        </Boton>

    )
}

				</Controles>

				{verRespuesta && (

					<Resultado
						correcto={
							esCorrecta
						}
					>

						<ResultadoTitulo>

							{esCorrecta
								? "✅ ¡Correcto!"
								: "❌ Incorrecto"}

						</ResultadoTitulo>

						<RenderContenido
  texto={
    preguntaActual?.respuesta_texto
  }
  latex={
    preguntaActual?.respuesta_latex
  }
/>

						{features.ver_imagenes &&
							imagenes.r?.map((img, i) => (

								<Imagen
									key={i}
									src={img}
									onClick={() =>
										abrirImagen(imagenes.r, i)
									}
								/>
							))}

{

evaluacionTema && (

<div
style={{

marginTop:"1.5rem",

padding:"1rem",

borderRadius:"16px",

background:"rgba(255,255,255,.05)",

border:"1px solid rgba(255,255,255,.08)"

}}

>

<div
style={{

fontWeight:"bold",

marginBottom:".7rem"

}}

>

🧠 Estado del conocimiento

</div>

<div>

Nivel actual:

<b>

{" "}

{evaluacionTema.nivelActual}

</b>

{" / "}

5

</div>

<div>

Objetivo:

<b>

{" "}

{evaluacionTema.nivelObjetivo}

</b>

</div>

<div>

Confianza:

<b>

{" "}

{Math.round(

evaluacionTema.confianza*100

)}

%

</b>

</div>

<div>

Resultado:

<b>

{

evaluacionTema.suficiente

?

" ✅ Suficiente"

:

" ⚠ En progreso"

}

</b>

</div>

</div>

)

}
					</Resultado>
				)}

				{/* =========================
    Barra inferior principal
========================= */}

			<Controles>

			<Boton
    ref={botonContinuarRef}
    onClick={() => {

		if (!verRespuesta) {
	
			if (esSimulacro) {
	
				siguiente();
	
			} else {
	
				setConfirmarRespuesta(true);
	
			}
	
			return;
	
		}
	
		siguiente();
	
	}}
    title="Continuar"
    disabled={
		procesando ||
		(!seleccion && !verRespuesta) ||
		hud.vidas <= 0
	}
>

    {
        verRespuesta
            ? "➡ Siguiente pregunta"
            : "✅ Responder"
    }

</Boton>

				<Boton
					title="Salir del Quiz"
					secundario
					onClick={() => {

						if (
							window.confirm(
								"¿Deseas finalizar esta sesión?"
							)
						) {
					
							setMostrarResumen(true);
					
						}
					
					}}
				>

✕ Salir

				</Boton>

			</Controles>
			</MainCard>

			{/* MODAL */}

			{modalImagenes.length > 0 && (

				<Modal onClick={cerrarModal}>

					<ModalContenido
						onClick={(e) => e.stopPropagation()}
					>

						<CloseBtn onClick={cerrarModal}>
							✕
						</CloseBtn>

						<ModalImagen
							src={modalImagenes[modalIndex]}
							x={pos.x}
							y={pos.y}
							zoom={zoom}
							onMouseDown={handleMouseDown}
							onMouseMove={handleMouseMove}
							onMouseUp={handleMouseUp}
							onWheel={(e) => {
								e.preventDefault();

								e.deltaY < 0
									? zoomIn()
									: zoomOut();
							}}
							onTouchStart={handleTouchStart}
							onTouchEnd={handleTouchEnd}
							draggable={false}
							onContextMenu={(e) =>
								e.preventDefault()
							}
						/>

						<NavModal>

							<SmallBtn onClick={prevImg}>
								⬅
							</SmallBtn>

							<SmallBtn onClick={zoomOut}>
								➖
							</SmallBtn>

							<SmallBtn onClick={zoomIn}>
								➕
							</SmallBtn>

							<SmallBtn onClick={nextImg}>
								➡
							</SmallBtn>

						</NavModal>

					</ModalContenido>

				</Modal>
			)}
			{floatingXp && (

			<FloatingXp>

				{floatingXp}

			</FloatingXp>

			)}
			{levelUpData && (

			<LevelOverlay>

				<ParticleContainer>

					{Array.from({ length: 40 }).map((_, i) => (

						<Particle
							key={i}
							left={Math.random() * 100}
							top={Math.random() * 100}
							duration={
								3 + Math.random() * 4
							}
						/>

					))}

				</ParticleContainer>

				<LevelCard>

					<LevelTitle>
						LEVEL UP
					</LevelTitle>

					<LevelSubtitle>
						Nivel {levelUpData.nivel}
					</LevelSubtitle>

					<LevelRango>
						🏅 {levelUpData.rango}
					</LevelRango>

				</LevelCard>

			</LevelOverlay>

			)}
			
			{hud.vidas <= 0 && (

			<LifeOverlay>

				<LifeCard>

					<Titulo>
						💔 Sin vidas
					</Titulo>

					<Subtitulo>

						Has agotado tus vidas por ahora.

						<br /><br />

						✨ Premium = vidas infinitas

					</Subtitulo>

					<Controles>

						<BotonBack to="/">
							🏠 Volver
						</BotonBack>

						<Boton
							onClick={() => {

								setHud((prev) => ({
									...prev,
									vidas: prev.vidasMax
								}));

								toast.success(
									"❤️ Vidas restauradas"
								);
							}}
						>

							❤️ Restaurar (demo)

						</Boton>

					</Controles>

				</LifeCard>

			</LifeOverlay>

			)}
			{confirmarRespuesta && (

<SummaryOverlay>

    <SummaryCard>

        <SummaryTitle>

            ¿Seguro de tu respuesta?

        </SummaryTitle>

        <Subtitulo
            style={{ textAlign:"center" }}
        >

            Después de revelar la respuesta ya no podrás modificarla.

        </Subtitulo>

        <SummaryButtons>

            <Boton
                secundario
                onClick={() =>
                    setConfirmarRespuesta(false)
                }
            >

                Seguir pensando

            </Boton>

            <Boton
                onClick={async () => {

                    setConfirmarRespuesta(false);

                    await cerrarPregunta();

                }}
            >

                Revelar respuesta

            </Boton>

        </SummaryButtons>

    </SummaryCard>

</SummaryOverlay>

)}
			{mostrarResumen && (() => {

			const total =
				sessionStats.correctas +
				sessionStats.incorrectas +
				sessionStats.neutras;

			const accuracy =
				total > 0
					? Math.round(
						(sessionStats.correctas / total) * 100
					)
					: 0;

			const tiempo =
				Math.floor(
					(Date.now() - sessionStats.inicio)
					/ 1000
				);

				console.log(
					"Tiempo sesión:",
					tiempo
				);

			const promedio =
				total > 0
					? Math.round(tiempo / total)
					: 0;

					const aprobado = accuracy >= 70;		

			let evaluacion = "Buen trabajo 🧠";

			if (
				esSimulacro &&
				accuracy >= 80
			) {
			
				evaluacion =
					"🏆 Región diagnosticada correctamente";
			}

			if (accuracy >= 90) {
				evaluacion = "Rendimiento ELITE 🔥";
			} else if (accuracy >= 75) {
				evaluacion = "Muy sólido ⚡";
			} else if (accuracy < 50) {
				evaluacion = "Sigue practicando 💪";
			}

			let recomendacion = "";

if (accuracy >= 90) {

    recomendacion =
        "Dominas este contenido. Puedes aumentar la dificultad.";

} else if (accuracy >= 75) {

    recomendacion =
        "Buen desempeño. Conviene reforzar algunos temas.";

} else if (accuracy >= 60) {

    recomendacion =
        "Hay avances, pero es recomendable volver a practicar.";

} else {

    recomendacion =
        "Se recomienda repetir este entrenamiento antes de continuar.";

}

			return (

				<SummaryOverlay>

					<SummaryCard>

					<SummaryTitle>
					{
	esSimulacro
		? "🧪 Simulacro completado"
		: "📊 Resumen de sesión"
}

{
    esSimulacro && (

        <div
            style={{
                marginBottom: "1rem",
                color: "#22c55e",
                fontWeight: "bold"
            }}
        >

            🌎 Nueva región disponible

        </div>
    )
}
					</SummaryTitle>

					<SummaryXp>
						+{sessionStats.xpGanada} XP
					</SummaryXp>

					{
    esSimulacro && (

        <div
            style={{
                color: "#facc15",
                fontWeight: "bold",
                marginBottom: "1rem"
            }}
        >

            👑 Región desbloqueada

        </div>
    )
}

<Subtitulo
    style={{
        textAlign: "center"
    }}
>
    🔥 {evaluacion}
</Subtitulo>

<SummaryValue
    style={{
        textAlign: "center",
        color: aprobado
            ? "#22c55e"
            : "#ef4444"
    }}
>
    {aprobado
        ? "APROBADO"
        : "REQUIERE REFUERZO"}
</SummaryValue>

<Subtitulo
    style={{
        textAlign: "center"
    }}
>
    {recomendacion}
</Subtitulo>


<Subtitulo
    style={{
        textAlign:"center",
        fontWeight:"bold"
    }}
>

{
    accuracy>=90
        ? "👑 Rango S"
        : accuracy>=80
        ? "🏆 Rango A"
        : accuracy>=70
        ? "🥇 Rango B"
        : accuracy>=60
        ? "🥈 Rango C"
        : "🥉 Rango D"
}

</Subtitulo>

						<SummaryGrid>
							<SummaryStat>

								<SummaryLabel>
									🎯 Accuracy
								</SummaryLabel>

								<SummaryValue>
									{accuracy}%
								</SummaryValue>

							</SummaryStat>

							<SummaryStat>

								<SummaryLabel>
									⚡ XP ganada
								</SummaryLabel>

								<SummaryValue>
									+{sessionStats.xpGanada}
								</SummaryValue>

							</SummaryStat>

							<SummaryStat>

								<SummaryLabel>
									✅ Correctas
								</SummaryLabel>

								<SummaryValue>
									{sessionStats.correctas}
								</SummaryValue>

							</SummaryStat>

							<SummaryStat>

								<SummaryLabel>
									⏱ Tiempo promedio
								</SummaryLabel>

								<SummaryValue>
									{promedio}s
								</SummaryValue>

							</SummaryStat>

							<SummaryStat>

    <SummaryLabel>

        ⌛ Tiempo total

    </SummaryLabel>

    <SummaryValue>

        {tiempo}s

    </SummaryValue>

</SummaryStat>

						</SummaryGrid>

						{
evaluacionTema && (

<SummaryStat
style={{
marginTop:"1.5rem"
}}
>

<SummaryLabel>

🧠 Diagnóstico del tema

</SummaryLabel>

<div
style={{
display:"flex",
flexDirection:"column",
gap:10
}}
>

<div>

Nivel

<b>

{" "}
{evaluacionTema.nivelActual}

/

{evaluacionTema.nivelObjetivo}

</b>

</div>

<div>

Precisión

<b>

{" "}
{Math.round(
evaluacionTema.precision*100
)}%

</b>

</div>

<div>

Persistencia

<b>

{" "}
{Math.round(
evaluacionTema.persistencia*100
)}%

</b>

</div>

<div>

Confianza

<b>

{" "}
{Math.round(
evaluacionTema.confianza*100
)}%

</b>

</div>

<div>

Estado

<b
style={{
color:
evaluacionTema.suficiente
? "#22c55e"
: "#ef4444"
}}
>

{
evaluacionTema.suficiente
? " ✅ Dominado"
: " ⚠ Requiere práctica"
}

</b>

</div>

</div>

</SummaryStat>

)
}

						{
	esSimulacro && (

		<Subtitulo
			style={{
				textAlign: "center",
				marginTop: "1rem"
			}}
		>

			{
				accuracy >= 80
				? "🟢 Dominio sólido"
				: accuracy >= 60
				? "🟡 Necesita refuerzo"
				: "🔴 Requiere reaprendizaje"
			}

		</Subtitulo>

	)
}
						<RewardBanner>

    🎁 Recompensas

	{
    esSimulacro && (

        <div>

            🏅 Logro:
            Primer diagnóstico completado

        </div>
    )
}

    <br />

    ⚡ +{sessionStats.xpGanada} XP

    <br />

    🎁 Recompensas obtenidas

</RewardBanner>
						<SummaryButtons>

						{!esSimulacro && (

<Boton
	onClick={async () => {

		setMostrarResumen(false);

		if (verRespuesta) {

			await siguiente();

		}

	}}
>

	🚀 Continuar racha

</Boton>

)}

						<BotonBack to="/">
							🏠 Volver al lobby
						</BotonBack>

						</SummaryButtons>

					</SummaryCard>

					</SummaryOverlay>
			);

			})()}

			{mostrarLevelUp && (

				<LevelUpOverlay>

					<LevelUpCard>

						<LevelUpTitle>
							LEVEL UP
						</LevelUpTitle>

						<SummaryXp>
							Nivel {hud.nivel}
						</SummaryXp>

						<LevelUpText>
							🔥 Tu conocimiento aumenta.
							<br />
							Sigue entrenando para desbloquear
							nuevos rangos y recompensas.
						</LevelUpText>

					</LevelUpCard>

				</LevelUpOverlay>
			)}

		</Contenedor>
	);
};

export default Quiz;